import client from './client';

/**
 * Approve a pending tool execution request.
 * Unblocks the Java backend and allows the tool to run on the runner.
 */
export async function approveToolExecution(conversationId: string, toolUseId: string): Promise<void> {
  await client.post(`/api/v1/conversations/${encodeURIComponent(conversationId)}/tool-approvals/${encodeURIComponent(toolUseId)}/approve`);
}

/**
 * Reject a pending tool execution request.
 * The AI agent will receive an error result instructing it to stop and explain.
 * @param comment Optional user comment explaining the reason for rejection.
 */
export async function rejectToolExecution(
  conversationId: string,
  toolUseId: string,
  comment?: string,
): Promise<void> {
  await client.post(
    `/api/v1/conversations/${encodeURIComponent(conversationId)}/tool-approvals/${encodeURIComponent(toolUseId)}/reject`,
    comment ? { comment } : undefined,
  );
}
